import DrSeussTile from "../../../assets/product-selector-tiles/dr-seuss.svg";
import GalileoTile from "../../../assets/product-selector-tiles/galileo.svg";
import ImagineReadingTile from "../../../assets/product-selector-tiles/imagine-reading.svg";
import IPATile from "../../../assets/product-selector-tiles/ipa.svg";
import LanguageAndLiteracyTile from "../../../assets/product-selector-tiles/language-and-literacy.svg";
import LecturaTile from "../../../assets/product-selector-tiles/lectura.svg";
import MyPathTile from "../../../assets/product-selector-tiles/mypath.svg";
import PurposeTile from "../../../assets/product-selector-tiles/purpose.svg";
import ScienceTile from "../../../assets/product-selector-tiles/science.svg";
import SpanishTile from "../../../assets/product-selector-tiles/spanish.svg";
import ProductEnum from "../../../enums/product-enum";

export type ProductTile = {
  title: string;
  image: any;
  mappedProducts: ProductEnum[];
  QaURL: string;
  StagingURL: string;
  ProductionURL: string;
};

const myPathURLs = {
  QaURL: "https://app.qa.edgenuityapp.com/launch?appfrom=mpp",
  StagingURL: "https://app.staging.edgenuityapp.com/launch?appfrom=mpp",
  ProductionURL: "https://app.edgenuity.com/launch?appfrom=mpp"
};

export const myPathProducts = [
  ProductEnum.MyPathReading,
  ProductEnum.MyPathReadingAlt,
  ProductEnum.MyPathMath,
  ProductEnum.MyPathMathAlt,
  ProductEnum.ImaginePlusMath,
  ProductEnum.Science,
  ProductEnum.ScienceAlt,
  ProductEnum.Purpose,
  ProductEnum.PurposeAlt
];

// Product tiles in order of display (based on the product selection screen from the universal login page)
export const orderedProductTiles: ProductTile[] = [
  {
    title: "Language and Literacy",
    image: LanguageAndLiteracyTile,
    mappedProducts: [ProductEnum.LanguageAndLiteracy, ProductEnum.LanguageAndLiteracyAlt],
    QaURL: "https://test.my.imaginelearning.com/signin?selectedProduct=ILE",
    StagingURL: "https://rc.my.imaginelearning.com/signin?selectedProduct=ILE",
    ProductionURL: "https://my.imaginelearning.com/signin?selectedProduct=ILE"
  },
  {
    title: "Dr. Seuss",
    image: DrSeussTile,
    mappedProducts: [], // Dr. Seuss is not mapped to a product; it is currently hardcoded with some orgs excluded in a flag
    QaURL: "https://test.my.imaginelearning.com/signin?selectedProduct=DrSeuss",
    StagingURL: "https://rc.my.imaginelearning.com/signin?selectedProduct=DrSeuss",
    ProductionURL: "https://my.imaginelearning.com/signin?selectedProduct=DrSeuss"
  },
  {
    title: "Imagine Espanol",
    image: SpanishTile,
    mappedProducts: [ProductEnum.ImagineEspanol, ProductEnum.ImagineEspanolAlt],
    QaURL: "https://test.my.imaginelearning.com/signin?selectedProduct=Spanish",
    StagingURL: "https://rc.my.imaginelearning.com/signin?selectedProduct=Spanish",
    ProductionURL: "https://my.imaginelearning.com/signin?selectedProduct=Spanish"
  },
  {
    title: "MyPath",
    image: MyPathTile,
    mappedProducts: [
      ProductEnum.MyPathReading,
      ProductEnum.MyPathReadingAlt,
      ProductEnum.MyPathMath,
      ProductEnum.MyPathMathAlt
    ],
    ...myPathURLs
  },
  {
    title: "Imagine+ Assessment",
    image: IPATile,
    mappedProducts: [ProductEnum.IPA],
    QaURL: "https://testassessment.imaginelearning.com",
    StagingURL: "https://rcassessment.imaginelearning.com",
    ProductionURL: "https://assessment.imaginelearning.com"
  },
  {
    title: "Imagine Purpose",
    image: PurposeTile,
    mappedProducts: [ProductEnum.Purpose, ProductEnum.PurposeAlt],
    ...myPathURLs
  },
  {
    title: "Imagine Science Corner",
    image: ScienceTile,
    mappedProducts: [ProductEnum.Science, ProductEnum.ScienceAlt],
    ...myPathURLs
  },
  {
    title: "Imagine Galileo",
    image: GalileoTile,
    mappedProducts: [ProductEnum.Galileo],
    QaURL: "https://aws-dev.ati-online.com/StudentCenter/ILToGalileoRedirect/Index",
    StagingURL: "https://galileodev.ati-online.com/StudentCenter/ILToGalileoRedirect/Index",
    ProductionURL: "https://www.assessmenttechnology.com/StudentCenter/ILToGalileoRedirect/Index"
  },
  {
    title: "Imagine Reading",
    image: ImagineReadingTile,
    mappedProducts: [ProductEnum.ImagineReading, ProductEnum.ImagineReadingAlt],
    QaURL: "https://test.my.imaginelearning.com/signin?selectedProduct=Reader",
    StagingURL: "https://rc.my.imaginelearning.com/signin?selectedProduct=Reader",
    ProductionURL: "https://my.imaginelearning.com/signin?selectedProduct=Reader"
  },
  {
    title: "Imagine Lectura",
    image: LecturaTile,
    mappedProducts: [ProductEnum.ImagineLectura, ProductEnum.ImagineLecturaAlt],
    QaURL: "https://test.my.imaginelearning.com/signin?selectedProduct=Lectura",
    StagingURL: "https://rc.my.imaginelearning.com/signin?selectedProduct=Lectura",
    ProductionURL: "https://my.imaginelearning.com/signin?selectedProduct=Lectura"
  }
];

export const ProductPortal: ProductTile = {
  title: "Product Portal",
  image: null,
  mappedProducts: [],
  QaURL: "https://testapi.imaginelearning.com/productSelection",
  StagingURL: "https://rcapi.imaginelearning.com/productSelection",
  ProductionURL: "https://api.imaginelearning.com/productSelection"
};

export const getProductTiles = (licensedProducts: ProductEnum[], currentProduct: ProductEnum) => {
  return orderedProductTiles.filter((tile) => {
    return (
      //user is licensed for the product mapped to the tile
      tile.mappedProducts.some((product) => licensedProducts.includes(product)) &&
      // user is not currently on the product mapped to the tile
      !tile.mappedProducts.includes(currentProduct) &&
      // product is not a MyPath product if the user is on a MyPath product
      !(
        myPathProducts.includes(currentProduct) &&
        tile.mappedProducts.some((product) => myPathProducts.includes(product))
      )
    );
  });
};
